<template>
<div class="chapter">
<div class="inner_page">
<p class="subtitle"><a id="page_iii"><em>FEARLESS</em> ™</a></p><a id="page_iii">
<h1 class="h1">BLOOD</h1>
<p class="author"><span class="small">FRANCINE PASCAL</span></p>
<p class="publisher"><img alt="Blood, by Francine Pascal. Simon Pulse." src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2e9129a0